// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const ContainerTitle = styled.div`
    background-image: url('/assets/ui/container-header-bg.png');
    background-repeat: no-repeat;
    background-position: top center;
    height: 46px;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: 'Open Sans Bold';
    padding-top: 20px;
    position: relative;
    top: 21px;
    z-index: 2;
`;

const Title = styled.h5`
    font-size: 9pt !important;
    padding: 0;
    margin: 0;
`;

const ContainerTitleComponent = ({ title }) => {
    return (
        <ContainerTitle>
            <Title>{title}</Title>
        </ContainerTitle>
    );
};

export default ContainerTitleComponent;
